export default __webpack_public_path__ + "static/media/02.e992f3b5.png";